export const iconMap: Record<string, string> = {
  clapperboard: 'ri-movie-2-line',
  film: 'ri-film-line',
  heart: 'ri-heart-3-line',
  focus: 'ri-focus-3-line',
  chart: 'ri-line-chart-line',
  archive: 'ri-archive-line',
  sparkling: 'ri-sparkling-2-line',
  search: 'ri-focus-2-line',
  contrast: 'ri-contrast-2-line',
  fire: 'ri-fire-line',
  reply: 'ri-chat-3-line',
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  flat: 'ri-subtract-line',
};

export const colorChip: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export const categoryIcon = (name: string): string => iconMap[name] || 'ri-folder-line';